// ===== STATUS BADGE =====
export const StatusBadge = ({ status }) => {
  const colors = {
    REQUESTED: "bg-yellow-100 text-yellow-800",
    APPROVED: "bg-green-100 text-green-800",
    AWAITING_FUNDS: "bg-blue-100 text-blue-800",
    PROCESSING: "bg-indigo-100 text-indigo-800",
    COMPLETED: "bg-emerald-100 text-emerald-800",
    FAILED: "bg-red-100 text-red-800",
    REJECTED: "bg-red-100 text-red-800",
    CANCELLED: "bg-gray-100 text-gray-800",
  };
  const colorClass = colors[status] || "bg-gray-100 text-gray-800";
  return (
    <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-semibold ${colorClass}`}>
      {status}
    </span>
  );
};

// ===== SUMMARY CARD =====
export const SummaryCard = ({ label, value, color }) => (
  <div className="bg-white rounded-lg border border-gray-200 p-4 flex-1 min-w-[160px]">
    <div className="text-xs font-medium text-gray-400 mb-1">{label}</div>
    <div className="text-2xl font-bold" style={{ color: color || "#1e293b" }}>{value}</div>
  </div>
);

export const DetailField = ({ label, value, valueColor }) => (
  <div>
    <div className="text-[11px] font-medium text-gray-400 uppercase tracking-wide mb-0.5">{label}</div>
    <div className={`text-sm font-medium ${valueColor || "text-gray-900"}`}>{value || "—"}</div>
  </div>
);

// ===== MOCK DATA =====
export const MOCK_WITHDRAWALS = [
  {
    id: 1,
    request_number: "WD-1001",
    resource_person_name: "John Doe",
    name: "John Doe",
    email: "john.doe@example.com",
    amount: 50000,
    available_balance: 125000,
    payment_method: "Bank Transfer",
    bank_name: "Access Bank",
    account_name: "John Doe",
    account_number: "0123456789",
    status: "PENDING",
    created_at: "2026-07-27T10:30:00Z",
    rejection_reason: null,
    earnings_breakdown: [
      { source: "Course Sales", amount: 85000 },
      { source: "Resource Downloads", amount: 45000 },
      { source: "Referral Earnings", amount: 20000 },
      { source: "Previous Withdrawal", amount: -50000 },
      { source: "Available Balance", amount: 100000 },
    ],
  },
  {
    id: 2,
    request_number: "WD-1002",
    resource_person_name: "Jane Smith",
    name: "Jane Smith",
    email: "jane.smith@example.com",
    amount: 35000,
    available_balance: 80000,
    payment_method: "PayPal",
    bank_name: "—",
    account_name: "Jane Smith",
    account_number: "9876543210",
    status: "APPROVED",
    created_at: "2026-07-26T14:20:00Z",
    rejection_reason: null,
    earnings_breakdown: [
      { source: "Course Sales", amount: 60000 },
      { source: "Resource Downloads", amount: 30000 },
      { source: "Referral Earnings", amount: 10000 },
      { source: "Previous Withdrawal", amount: -20000 },
      { source: "Available Balance", amount: 80000 },
    ],
  },
  {
    id: 3,
    request_number: "WD-1003",
    resource_person_name: "Mike Adams",
    name: "Mike Adams",
    email: "mike.adams@example.com",
    amount: 75000,
    available_balance: 150000,
    payment_method: "Bank Transfer",
    bank_name: "GTBank",
    account_name: "Mike Adams",
    account_number: "5678901234",
    status: "REJECTED",
    created_at: "2026-07-25T09:15:00Z",
    rejection_reason: "Invalid bank details. Please update your payment information and submit a new request.",
    earnings_breakdown: [
      { source: "Course Sales", amount: 120000 },
      { source: "Resource Downloads", amount: 55000 },
      { source: "Referral Earnings", amount: 15000 },
      { source: "Previous Withdrawal", amount: -40000 },
      { source: "Available Balance", amount: 150000 },
    ],
  },
  {
    id: 4,
    request_number: "WD-1004",
    resource_person_name: "Sarah Wilson",
    name: "Sarah Wilson",
    email: "sarah.wilson@example.com",
    amount: 25000,
    available_balance: 45000,
    payment_method: "Bank Transfer",
    bank_name: "First Bank",
    account_name: "Sarah Wilson",
    account_number: "3456789012",
    status: "PAID",
    created_at: "2026-07-24T16:45:00Z",
    rejection_reason: null,
    earnings_breakdown: [
      { source: "Course Sales", amount: 40000 },
      { source: "Resource Downloads", amount: 20000 },
      { source: "Referral Earnings", amount: 5000 },
      { source: "Previous Withdrawal", amount: -20000 },
      { source: "Available Balance", amount: 45000 },
    ],
  },
  {
    id: 5,
    request_number: "WD-1005",
    resource_person_name: "David Lee",
    name: "David Lee",
    email: "david.lee@example.com",
    amount: 100000,
    available_balance: 200000,
    payment_method: "PayPal",
    bank_name: "—",
    account_name: "David Lee",
    account_number: "7890123456",
    status: "PENDING",
    created_at: "2026-07-23T11:00:00Z",
    rejection_reason: null,
    earnings_breakdown: [
      { source: "Course Sales", amount: 150000 },
      { source: "Resource Downloads", amount: 70000 },
      { source: "Referral Earnings", amount: 30000 },
      { source: "Previous Withdrawal", amount: -50000 },
      { source: "Available Balance", amount: 200000 },
    ],
  },
  {
    id: 6,
    request_number: "WD-1006",
    resource_person_name: "Olivia Davis",
    name: "Olivia Davis",
    email: "olivia.davis@example.com",
    amount: 15000,
    available_balance: 30000,
    payment_method: "Bank Transfer",
    bank_name: "UBA",
    account_name: "Olivia Davis",
    account_number: "2345678901",
    status: "CANCELLED",
    created_at: "2026-07-22T08:30:00Z",
    rejection_reason: "Request cancelled by user",
    earnings_breakdown: [
      { source: "Course Sales", amount: 25000 },
      { source: "Resource Downloads", amount: 10000 },
      { source: "Referral Earnings", amount: 5000 },
      { source: "Previous Withdrawal", amount: -10000 },
      { source: "Available Balance", amount: 30000 },
    ],
  },
];